module.exports = __webpack_public_path__ + "img/no-data.b0e90cbe.svg";